import { render } from "./tip.vue?vue&type=template&id=4ede7ec9"
import script from "./tip.vue?vue&type=script&lang=js"
export * from "./tip.vue?vue&type=script&lang=js"

import "./tip.vue?vue&type=style&index=0&id=4ede7ec9&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__